var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 0.833374C7.166 0.833374 0.833496 7.16587 0.833496 15C0.833496 22.8342 7.166 29.1667 15.0002 29.1667C22.8343 29.1667 29.1668 22.8342 29.1668 15C29.1668 7.16587 22.8343 0.833374 15.0002 0.833374ZM15.0002 26.3334C8.75266 26.3334 3.66683 21.2475 3.66683 15C3.66683 8.75254 8.75266 3.66671 15.0002 3.66671C21.2477 3.66671 26.3335 8.75254 26.3335 15C26.3335 21.2475 21.2477 26.3334 15.0002 26.3334ZM20.086 7.91671L15.0002 13.0025L9.91433 7.91671L7.91683 9.91421L13.0027 15L7.91683 20.0859L9.91433 22.0834L15.0002 16.9975L20.086 22.0834L22.0835 20.0859L16.9977 15L22.0835 9.91421L20.086 7.91671Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.2678ff08148e3dee4f3e9ec8f58c86a5.svg";
export { ForwardRef as ReactComponent };